import { buildSlice, CommonState } from '~libs/reduxUtils';
import { Worker } from '~weekly-planner/lib/common';

import { getOne, typePrefix } from '~dashboard/components/user-calendar/actions/users';

interface State extends CommonState<Worker> {
  params: { [key: string]: any };
  filterOptions?: { [key: string]: any };
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  params: {},
  rows: [],
};

const slice = buildSlice<State, Worker>(typePrefix, initialState, {
  extraReducers: (builder) => {
    builder.addCase(getOne.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.rows = action.payload.data;
      state.hasLoaded = true;
    });
  },
});

export default slice.reducer;
